<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="languagesSummary && languagesProgress && schoolSummary">
			<title-bar title="Progreso por idiomas" :percentage="schoolSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<div class="row between innerRubric">
				<div class="compareGeneral">
					<progress-chart :data="chartsProperties.data" :legend="true"/>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		schoolSummary () {
			if (this.$store.state.school.summary) return this.$store.state.school.summary[0];
			else return this.$store.state.school.summary;
		},
		schoolProgress () {
			return this.$store.state.school.progress;
		},
		languagesSummary () {
			return this.$store.state.languages.summary;
		},
		languagesProgress () {
			return this.$store.state.languages.progress;
		},
		chartsProperties () {
			if (!this.schoolProgress && !this.languagesProgress) return {};
			let chartProperties = {
				type: 'line',
				data: {
					labels: this.schoolProgress.map((visit) => {
						return `Visita ${visit.number}`;
					}),
					datasets: this.languagesProgress.map((language) => {
						return {
							data: language.progress.map((visit) => {
								if (visit.coachingCategories.length > 0) return parseInt(visit.percentage);
								else return null;
							}),
							label: language.language.name,
							borderWidth: 2,
							fill: false,
							borderColor: this.getChartColors(language.language.isoCode).border,
							backgroundColor: this.getChartColors(language.language.isoCode).background,
							dates: language.progress.map((visit) => {
								return this.getHumanDate(visit.date);
							})
						};
					})
				}
			};
			chartProperties.data.datasets.push({
				data: this.schoolProgress.map((visit) => {
					if (visit.coachingCategories.length > 0) return parseInt(visit.percentage);
					else return null;
				}),
				label: 'General',
				borderWidth: 2,
				fill: false,
				dates: this.schoolProgress.map((visit) => {
					return this.getHumanDate(visit.date);
				})
			});
			return chartProperties;
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		},
		getChartColors (isoCode) {
			if (isoCode == 'es') return {background: '#FDAA72', border: '#FDAA72'};
			else if (isoCode == 'en') return {background: '#8e5ea2', border: '#8e5ea2'};
			else return {background: 'rgba(74, 144, 226, 1)', border: 'rgba(74, 144, 226, 1)'};
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../../scss/vars.scss";
.compare {
	position: relative;
	&Container {
		display: flex;
		padding: 0 1rem;
		justify-content: space-between;
		width: 100%;
		max-width: 144rem;
		height: 60rem;
		position: relative;
	}
	&General {
		margin-top: 3rem;
		width: 100%;
	}
	&All {
		margin: 0;
		height: 45rem;
		width: 49%;
		& > .card {
			border: none;
		}
	}
}

.colHalf.rubric {
	margin-top: 0;
	width: 100%;
}
.innerRubric {
	align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/routes/languages/GeneralProgress.vue